/**
 * useMembershipResignationPort — port-factory hook returning a stable
 * MembershipResignationPort adapter (056).
 *
 * The composer and the test harness call this once to obtain the port for
 * PortsProvider; useState's lazy initialiser keeps the reference stable.
 * Constructs the REAL tRPC-backed adapter over `member.resignation.submit`.
 */

import { useState } from 'react';

import type { MembershipResignationPort } from '../membership-resignation/MembershipResignationPort.js';
import { TrpcMembershipResignationAdapter } from '../membership-resignation/TrpcMembershipResignationAdapter.js';
import { createWebTrpcClient } from '../trpc/client.js';

export function useMembershipResignationPort(): MembershipResignationPort {
  const [port] = useState<MembershipResignationPort>(
    () => new TrpcMembershipResignationAdapter(createWebTrpcClient()),
  );
  return port;
}
